<template>
	<div>
		<ul class="navbar-nav ml-auto nav-flex-icons">
			<li class="nav-item dropdown">
				<a class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					<i class="fas fa-user"></i>
					Opções
				</a>
				<div class="dropdown-menu dropdown-menu-right dropdown-default" aria-labelledby="navbarDropdownMenuLink-333">
					<router-link class="dropdown-item" to="/informacoes">
						<i class="fas fa-users-cog"></i>
						Minhas Informações
					</router-link>
					<router-link class="dropdown-item" to="/senha">
						<i class="fa fa-key" aria-hidden="true"></i>
						Alterar senha
					</router-link>
					<router-link class="dropdown-item" to="/" @click.native.prevent="logout">
						<i class="fas fa-sign-out-alt"></i>
						Logout
					</router-link>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'NavBarMenu',
	props: {
		showMenu: Boolean,
	},
	methods: {
		logout() {
			this.$auth.logout({
				makeRequest: true,
				success: function(retorno) {
					this.$toasted.global.defaultSuccess({ mensagem: retorno.data.mensagem });
				},
				error: function() {},
			});
		},
	},
};
</script>

<style scoped></style>
